import {
  getHistoryAPI,
  getResultPayment as getResultPaymentAPI,
  getProcessingResultAPI,
  privacyPolicyAPI,
  refundAPI,
  reserveBarAPI,
  reserveTicketAPI,
  submitOrderAPI,
  useDiscountPromoCodeAPI,
} from '../helpers/api';
import request from '../helpers/request';
import store from '../store/store';

export const getHistory = async () => {
  return await request(getHistoryAPI());
};

export const getProcessingResult = async (data, userSessionGuid) => {
  return await request(
    getProcessingResultAPI(data),
    'GET',
    {},
    { userSessionGuid },
  );
};

export const getResultPayment = async (data, userSessionGuid) => {
  return await request(getResultPaymentAPI(data), 'GET', {}, { userSessionGuid });
};

export const reserveBar = async (data, userSessionGuid) => {
  return await request(reserveBarAPI(), 'POST', data, {
    frontType: store.getters.frontType,
    userSessionGuid,
  });
};

export const reserveTicket = async (data, userSessionGuid, authToken) => {
  return await request(
    reserveTicketAPI(),
    'POST',
    data,
    { frontType: store.getters.frontType, userSessionGuid },
    authToken,
  );
};

export const useDiscountPromoCode = async (
  data,
  userSessionGuid,
  authToken,
) => {
  return await request(
    useDiscountPromoCodeAPI(),
    'POST',
    data,
    { userSessionGuid },
    authToken,
  );
};

export const submitOrder = async (data, userSessionGuid) => {
  return await request(submitOrderAPI(), 'POST', data, {
    userSessionGuid,
    frontType: store.getters.frontType,
  });
};

export const refund = async (data, userSessionGuid) => {
  return await request(refundAPI({ userSessionGuid }), 'POST', data);
};

export const privacyPolicy = async (theatreId) => {
  return await request(privacyPolicyAPI(), 'GET', null, theatreId);
};
